import VideoCard from '@/components/feature/VideoCard';

const hotVideoList = [
  {
    id: 'v001',
    title: '星际穿越：超越时空的史诗之旅',
    category: '科幻奇幻',
    categorySlug: 'kehuan',
    duration: '2:49:32',
    views: '1280万',
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20space%20exploration%20cinematic%20scene%20with%20distant%20galaxy%20and%20starship%2C%20dramatic%20warm%20lighting%2C%20cinematic%20composition%2C%20deep%20space%20atmosphere%2C%20professional%20film%20photography%2C%20clean%20dark%20gradient%20background&width=640&height=360&seq=hot-v001&orientation=landscape',
  },
  {
    id: 'v002',
    title: '功夫之王：龙争虎斗传奇',
    category: '动作大片',
    categorySlug: 'dongzuo',
    duration: '2:05:18',
    views: '960万',
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Martial%20arts%20action%20film%20cinematic%20scene%20with%20dynamic%20fight%20choreography%2C%20dramatic%20golden%20hour%20lighting%2C%20epic%20composition%2C%20warm%20intense%20tones%2C%20professional%20film%20photography%2C%20clean%20background&width=640&height=360&seq=hot-v002&orientation=landscape',
  },
  {
    id: 'v003',
    title: '欢乐喜剧人：笑傲江湖',
    category: '喜剧搞笑',
    categorySlug: 'xiju',
    duration: '1:38:45',
    views: '850万',
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20funny%20comedy%20film%20cinematic%20scene%20with%20colorful%20set%20design%2C%20cheerful%20warm%20lighting%2C%20playful%20composition%2C%20vibrant%20joyful%20tones%2C%20professional%20film%20photography%2C%20clean%20light%20background&width=640&height=360&seq=hot-v003&orientation=landscape',
  },
  {
    id: 'v004',
    title: '深海奇缘：未知世界的探索',
    category: '纪录纪实',
    categorySlug: 'jilu',
    duration: '1:52:10',
    views: '720万',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20cinematic%20scene%20with%20bioluminescent%20sea%20creatures%2C%20mysterious%20blue-green%20underwater%20lighting%2C%20epic%20wide%20composition%2C%20professional%20nature%20photography%2C%20clean%20dark%20aquatic%20background&width=640&height=360&seq=hot-v004&orientation=landscape',
  },
  {
    id: 'v005',
    title: '千与千寻：神隐少女的奇幻冒险',
    category: '动漫动画',
    categorySlug: 'dongman',
    duration: '2:05:00',
    views: '1580万',
    rating: 9.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20animated%20cinematic%20scene%20with%20magical%20spirit%20world%2C%20soft%20warm%20golden%20lighting%2C%20dreamy%20composition%2C%20rich%20vibrant%20colors%2C%20artistic%20animation%20style%2C%20clean%20gradient%20background&width=640&height=360&seq=hot-v005&orientation=landscape',
  },
  {
    id: 'v006',
    title: '山河故人：岁月里的温情记忆',
    category: '剧情文艺',
    categorySlug: 'juqing',
    duration: '2:11:23',
    views: '650万',
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Poetic%20drama%20film%20cinematic%20scene%20with%20nostalgic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20intimate%20composition%2C%20warm%20muted%20tones%2C%20artistic%20film%20photography%2C%20clean%20gentle%20background&width=640&height=360&seq=hot-v006&orientation=landscape',
  },
];

export default function HotVideosSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">全网最受欢迎的高清视频精选</p>
          </div>
          <a
            href="/category/dongzuo"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotVideoList.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <a
            href="/category/dongzuo"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            查看全部热门视频
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}